import { apiClient } from "@/api";

export interface FeedbackPayload {
    form_type: string;
    stars: number;
    feedback?: string;
}

export interface FeedbackUpdatePayload {
    stars: number;
    feedback?: string;
}

export interface FeedbackParams {
    search?: string;
    form_type?: string;
    stars?: number | string;
    date_from?: string;
    date_to?: string;
    order_by?: string;
    order?: string;
    pagination?: number;
    page?: number;
}

export const submitFeedback = async (data: FeedbackPayload) => {
    try {
        const response = await apiClient.post("/feedbacks", data);
        return response.data;
    } catch (error: any) {
        if (error?.response?.data) {
            return Promise.reject(error.response.data);
        } else {
            return Promise.reject(error);
        }
    }
};

export const updateFeedback = async (id: number, data: FeedbackUpdatePayload) => {
    try {
        const response = await apiClient.put(`/feedbacks/${id}`, data);
        return response.data;
    } catch (error: any) {
        if (error?.response?.data) {
            return Promise.reject(error.response.data);
        } else {
            return Promise.reject(error);
        }
    }
};

export const deleteFeedback = async (id: number) => {
    try {
        const response = await apiClient.delete(`/feedbacks/${id}`);
        return response.data;
    } catch (error: any) {
        if (error?.response?.data) {
            return Promise.reject(error.response.data);
        } else {
            return Promise.reject(error);
        }
    }
};

export const getFeedbacks = async (params: FeedbackParams = {}) => {
    try {
        const response = await apiClient.get("/feedbacks", { params });
        return response.data;
    } catch (error: any) {
        if (error?.response?.data) {
            return Promise.reject(error.response.data);
        } else {
            return Promise.reject(error);
        }
    }
};
